import { Component } from '@angular/core';
import { LottieComponent } from 'ngx-lottie';

@Component({
  selector: 'app-ping',
  standalone: true,
  imports: [LottieComponent],
  template: ` <ng-lottie [options]="options" width="60px" height="60px"></ng-lottie> `
})
export class PingComponent {
  options = {
    path: 'assets/animations/ping.json', // relative to /src
    loop: true,
    autoplay: true
  };
}
